import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { Card, CardBody } from "@heroui/react";
import { ChevronRight, Search, Store } from "lucide-react";
import type { ReactNode } from "react";
import type { RegisterRole } from "./registerRole";

export function RegisterRoleChoice({
  onSelect,
}: {
  onSelect: (role: RegisterRole) => void;
}) {
  return (
    <div className="flex flex-col gap-3">
      <p className="text-center font-medium text-default-600 text-sm">
        <Trans>Kako boste uporabljali Lime Booking?</Trans>
      </p>

      <RoleOption
        identifier="register-role-business"
        icon={<Store size={22} />}
        title={t`Sem ponudnik storitev`}
        description={t`Ustvarite račun in upravljajte svoje termine.`}
        onPress={() => onSelect("business")}
      />

      <RoleOption
        identifier="register-role-customer"
        icon={<Search size={22} />}
        title={t`Iščete storitev?`}
        description={t`Prenesite aplikacijo in rezervirajte termin v nekaj klikih.`}
        onPress={() => onSelect("customer")}
      />
    </div>
  );
}

function RoleOption({
  identifier,
  icon,
  title,
  description,
  onPress,
}: {
  identifier: string;
  icon: ReactNode;
  title: string;
  description: string;
  onPress: () => void;
}) {
  return (
    <Card
      isPressable
      shadow="sm"
      onPress={onPress}
      data-identifier={identifier}
      className="w-full border border-default-200"
    >
      <CardBody className="flex flex-row items-center gap-4 p-4">
        <div className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
          {icon}
        </div>

        <div className="flex flex-1 flex-col text-left">
          <p className="font-semibold">{title}</p>
          <p className="text-default-500 text-sm">{description}</p>
        </div>

        <ChevronRight size={18} className="shrink-0 text-default-400" />
      </CardBody>
    </Card>
  );
}
